import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { SkillsSection } from "@/components/SkillsSection";
import { Features } from "@/components/Features";
import { Model3DViewer } from "@/components/Model3DViewer";
import { ProductShowcase } from "@/components/ProductShowcase";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { StructuredData } from "@/components/StructuredData";

import { useTracking } from "@/hooks/useTracking";

const Index = () => {
  // Initialize tracking
  useTracking();
  
  return (
    <div className="min-h-screen bg-background">
      <StructuredData />
      
      {/* Skip to content link for accessibility */}
      <a 
        href="#main-content" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-lg focus:shadow-glow"
      >
        Zum Hauptinhalt springen
      </a>
      
      <Navigation />
      <main id="main-content">
        <Hero />
        <SkillsSection />
        <Features />
        <Model3DViewer />
        <ProductShowcase />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
